<header class="app-header">
  <div class="app-header__left">
    <button
      *ngIf="isLogged$ | async"
      type="button"
      class="app-header__toggle"
      aria-label="Alternar menu"
      (click)="toggleSidenav()"
    >
      <i class="fa-solid fa-bars"></i>
    </button>
    <a routerLink="/home" class="app-header__logo">
      <img src="assets/images/logo-affix.svg" alt="Affix" />
    </a>
  </div>

  <div class="app-header__right" *ngIf="user$ | async as user">
    <span class="app-header__username">{{ user.username }}</span>
    <span class="app-header__avatar">{{ user.username.charAt(0).toUpperCase() }}</span>
  </div>
</header>
